<template>
<div class="fff">
  <div class="apps_title">{{$t('apps.title')}}</div>
  <!-- <div class="apps_title">Basic</div> -->
  <div class="apps_ul">
    <div class="apps_li" v-for="(val,key) in list" :key="key">
      <img v-if="val.icon" :src="'data:image/png;base64,'+val.icon">
      <img v-else src="@/assets/img//img.png">
      {{val.app_name1?val.app_name1:val.name}}
    </div>
  </div>
   <div class="noData" v-if="list.length <= 0 && status">{{$t('apps.no')}}</div>

</div>
</template>

<script>
import {App} from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      key: {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 9999
      },
      list: [],
      msg: '',
      status: null
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    getlist () {
      this.list = []
      App(this.key).then((adj) => {
        this.list = adj.data.list
        this.status = 1
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:97%;margin:20px auto;background:#fff;border-radius:12px;-webkit-box-shadow:0 4px 12px -4px rgba(122,138,153,.2);box-shadow:0 4px 12px -4px rgba(122,138,153,.2);overflow:hidden;padding-bottom:60px}
.apps_title{line-height:55px;padding-top:10px;height:55px;text-indent:2.5%;font-size:14px;color:#000927;font-weight:700}
.apps_ul{overflow:hidden;width:100%;margin-bottom:-20px}
.apps_li{float:left;width:29%;margin-left:2.5%;border:1px solid #e1e3e6;border-radius:12px;line-height:68px;height:68px;font-size:14px;overflow:hidden;margin-bottom:20px}
.apps_li img{display:block;width:32px;height:32px;float:left;margin:18px 10px 0 16px}
.apps_li .Block{float:right;margin:22px}

</style>



// WEBPACK FOOTER //
// src/components/Apps.vue